import { SearchX, Star } from "lucide-react";
import { Button } from "./ui/button";

interface EmptyStateProps {
  kind: "dataset" | "filtered" | "signed-out-watchlist";
  onReset: () => void;
  onSignIn: () => void;
  datasetMode?: "demo" | "partial";
}

export function EmptyState({ kind, onReset, onSignIn, datasetMode }: EmptyStateProps) {
  if (kind === "signed-out-watchlist") {
    return (
      <div className="flex min-h-[300px] flex-col items-center justify-center border-x border-b border-border bg-surface p-8 text-center">
        <Star className="h-8 w-8 text-muted-foreground" aria-hidden="true" />
        <h2 className="mt-3 text-sm font-semibold">Sign in to view My Watchlist</h2>
        <p className="mt-1 max-w-md text-xs leading-5 text-muted-foreground">
          Sign in with email to load your saved favorite tickers. Your complete current screener URL
          stays in place after sign-in.
        </p>
        <Button className="mt-4" variant="outline" size="sm" onClick={onSignIn}>
          Sign in
        </Button>
      </div>
    );
  }

  if (kind === "dataset") {
    const modeName = datasetMode === "demo" ? "demo" : "partial";
    return (
      <div className="flex min-h-[300px] flex-col items-center justify-center border-x border-b border-border bg-surface p-8 text-center">
        <SearchX className="h-8 w-8 text-muted-foreground" aria-hidden="true" />
        <h2 className="mt-3 text-sm font-semibold">No transactions in this dataset</h2>
        <p className="mt-1 max-w-md text-xs leading-5 text-muted-foreground">
          The declared dataset currently contains no transactions. This is a {modeName} dataset;
          its coverage and validation details remain available in Coverage.
        </p>
      </div>
    );
  }

  return (
    <div className="flex min-h-[300px] flex-col items-center justify-center border-x border-b border-border bg-surface p-8 text-center">
      <SearchX className="h-8 w-8 text-muted-foreground" aria-hidden="true" />
      <h2 className="mt-3 text-sm font-semibold">No insider trades match these filters</h2>
      <p className="mt-1 max-w-md text-xs leading-5 text-muted-foreground">
        Remove an active filter chip above, relax the current controls, or reset the screener.
      </p>
      <Button className="mt-4" variant="outline" size="sm" onClick={onReset}>
        Reset filters
      </Button>
    </div>
  );
}
